import { render, staticRenderFns } from "./Migrate.vue?vue&type=template&id=7c7f3c1f&scoped=true"
import script from "./Migrate.vue?vue&type=script&lang=js"
export * from "./Migrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7f3c1f",
  null
  
)

export default component.exports